import { useTranslation } from "react-i18next";
import { GrappleModule } from "../../interfaces/api/GrappleModule";
import { LowerBracket } from "../../interfaces/api/LowerBracket";
import { MachineFixing } from "../../interfaces/api/MachineFixing";
import { Rototilt } from "../../interfaces/api/Rototilt";
import { UpperBracket } from "../../interfaces/api/UpperBracket";
import { ProductType } from "../../shared/enums/ProductType";
import { productHelper } from "../../shared/helpers/productHelper";
import { ProductItem } from "../../shared/types/ProductItem";
import ListDesktop from "../shared/ListTable/ListDesktop";
import ListItem from "../shared/ListTable/ListItem";
import ListItemImage from "../shared/ListTable/ListItemImage";
import ListMobile from "../shared/ListTable/ListMobile";
import ListRow, { ListSelectMode } from "../shared/ListTable/ListRow";

interface ProductListItemProps {
  configLink: string;
  market: string;
  product:
    | GrappleModule
    | LowerBracket
    | MachineFixing
    | Rototilt
    | UpperBracket
    | ProductItem;
  productType?: ProductType;
}

const ProductListItem = ({
  configLink,
  market,
  product,
  productType,
}: ProductListItemProps) => {
  const { t } = useTranslation([
    "cart",
    "machinefixings",
    "tiltrotator",
    "tools",
  ]);

  const widthNameColumn = "150px";
  const widthColumn = "130px";

  const productData = productHelper.getProductData({
    market,
    product,
    productType,
    t,
  });
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  const onChangeDummy = () => {};

  return (
    <ListRow
      configLink={configLink}
      key={productData.name}
      isSelected={false}
      identifier={productData.name}
      object={product}
      onChange={onChangeDummy}
      selectMode={ListSelectMode.Config}
    >
      <>
        <ListDesktop>
          <ListItemImage product={productData} />
          <ListItem
            label={productData.nameLabel}
            maxWidth={widthNameColumn}
            minWidth={widthNameColumn}
            truncate
            value={productData.name}
          />
          {productData.properties.map((property, index) => {
            return (
              <ListItem
                key={`property-${index}`}
                label={property.label}
                maxWidth={widthColumn}
                minWidth={widthColumn}
                truncate
                value={property.text}
              />
            );
          })}
        </ListDesktop>
      </>
      <ListMobile
        configLink={configLink}
        content={productHelper.getHtmlContent(productData)}
        imageLink={productData.imageLink}
        isSelected={false}
        object={product}
        onChange={onChangeDummy}
        preContent={productData.nameLabel}
        selectMode={ListSelectMode.Config}
        readMeUrl=""
        title={productData.name}
      />
    </ListRow>
  );
};

export default ProductListItem;
